import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSKrossBookingStore = GenericCollectionFactory("PMS-KROSS-BOOKING-INTEGRATION", "id_property");